import React, {useCallback, useEffect, useState} from "react";
import "quill/dist/quill.snow.css";
import "./style.scss"
import Quill from "quill";

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'align': 'justify'}, {'align': 'center'}, {'align': 'right'}],
  ['link'],

];

export default function Editor({handleChangeFunc, typeOfDesc, dataToPrefill, enableEdit}) {
  const [quillInstance, setQuillInstance] = useState(null);

  const wrapperRef = useCallback((wrapper) => {
    if (wrapper == null) return;
    wrapper.innerHTML = "";
    const editor = document.createElement("div");
    wrapper.append(editor);

    const quill = new Quill(editor, {
      theme: "snow",
      modules: {
        toolbar: null
      },
    });
    quill.enable(enableEdit);
    setQuillInstance(quill);
    quill.root.innerHTML = dataToPrefill;
    quill.on('text-change', (delta, name, source) => {
      if (source !== 'user') return;
      const content = quill.root.innerHTML;
      handleChangeFunc(typeOfDesc, content);
      autoExpandEditor(quill);
    });
    quill.root.style.minHeight = '150px';
    quill.root.style.cursor = 'text';
  }, [enableEdit]);

  const autoExpandEditor = (quill) => {
    const editorContentElement = quill.root;
    editorContentElement.style.height = "auto";
    editorContentElement.style.height = `${editorContentElement.scrollHeight}px`;
  };

  useEffect(() => {
    if (quillInstance && dataToPrefill) {
      quillInstance.root.innerHTML = dataToPrefill;
      autoExpandEditor(quillInstance);
    }
  }, [quillInstance, dataToPrefill]);

  useEffect(() => {
    if (quillInstance) {
      quillInstance.enable(enableEdit);
      quillInstance.root.style.cursor = enableEdit ? 'text' : 'default';
    }
  }, [enableEdit, quillInstance]);

  useEffect(() => {
    if (quillInstance) {
      autoExpandEditor(quillInstance);
    }
  }, [quillInstance]);

  return (
    <div>
      <div className="custom-toolbar-example" ref={wrapperRef}></div>
    </div>

  );
}